<template>
  <VModal ref="modal" @modal:hidden="$emit('close')">
    <template #default>
      <VDialog title="New Task" class="max-w-lg" @close="$refs.modal.close()">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
          <form @submit.prevent="handleSubmit(submit)" class="space-y-8">
            <ValidationProvider rules="required" v-slot="{ errors, failed }" slim>
              <BaseFormGroup>
                <BaseFormLabel> Title * </BaseFormLabel>
                <BaseFormInput v-model="data.title" :invalid="failed" :disabled="submitting" />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </ValidationProvider>
            <BaseButton primary type="submit" :disabled="invalid || submitting"> Open </BaseButton>
          </form>
        </ValidationObserver>
      </VDialog>
    </template>
  </VModal>
</template>

<script>
import VDialog from '@/components/Common/VDialog.vue';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  name: 'CreateTaskModal',
  mixins: [veeValidateErrorsMixin],
  components: {
    VDialog,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
    defaultData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      data: {
        ...this.defaultData,
      },
      submitting: false,
    };
  },
  methods: {
    async submit() {
      this.submitting = true;

      try {
        const { taskId } = await this.$store.dispatch({
          type: 'ui/projectTasks/store',
          projectId: this.projectId,
          formData: this.data,
        });

        this.$emit('created', taskId);

        this.$refs.modal.close();
      } catch (errors) {
        this.observer = this.$refs.observer;
        this.addServerErrors(errors.data.errors);
        this.submitting = false;
      }
    },
  },
};
</script>
